import createPage from "@src/components/page"
import React from "react"
import * as styles from "./pageTotal.module.scss"

import d1Image from "@images/png/6.png"
import d2Image from "@images/png/7.png"
import { secondsToHours } from "@src/utils/data-parser"
import Numbers from "@src/components/numbers"
import { callYou, useEnteringTrail } from "@src/components/page/lib"
import { animated } from "react-spring"
import { whiteColor } from "@config"

const parseData = (data) => {
  return {
    total: data.attributes["radio-plays-count"],
    listen: secondsToHours(data.attributes["time-spent-listening"] * 60),
  }
}

const PageTotal = createPage(
  ({ data, offset }) => {
    const {
      total,
      listen: { hours, minutes, seconds },
    } = parseData(data)
    const target = callYou(data)
    const anime1Styles = useEnteringTrail(2, offset)
    const anime2Styles = useEnteringTrail(1, offset, { step: 0.4, type: "mrt" })
    const anime3Styles = useEnteringTrail(1, offset, { step: 0.6, type: "mlb" })
    const anime4Styles = useEnteringTrail(1, offset, { step: 0.9 })
    return (
      <>
        <div>
          <animated.img
            style={anime2Styles[0]}
            className={styles.d1}
            src={d1Image}
            alt="装饰图片1"
          />
        </div>
        <animated.div style={anime1Styles[0]}>
          <div>2021年 {target}一共听了</div>
          <div className={styles.line1}>
            <Numbers className={styles.totalNumbers}>{total}</Numbers>
            期节目
          </div>
        </animated.div>
        <animated.div style={anime1Styles[1]} className={styles.listenLine}>
          {hours && (
            <span>
              <Numbers className={styles.hoursNumbers}>{hours}</Numbers>
              小时
            </span>
          )}
          <span>
            <Numbers>{minutes || seconds}</Numbers>
            {minutes ? "分钟" : "秒"}
          </span>
          <br />
          是机核陪{target}度过的
        </animated.div>
        <div>
          <animated.img
            style={anime3Styles[0]}
            className={styles.d2}
            src={d2Image}
            alt="装饰图片1"
          />
        </div>
        <animated.div className="bottomText" style={anime4Styles[0]}>
          2021 年机核全年共制作 757 期节目
          <br />
          节目总时长 636 小时 46 分钟
        </animated.div>
      </>
    )
  },
  {
    className: styles.page,
  }
)

export const pageTotalData = {
  key: "total",
  bg: whiteColor,
  Page: PageTotal,
  shouldHide: (data) => data.attributes["radio-plays-count"] === 0,
}

export default PageTotal
